import React from 'react'
import styles from './styles.css'
import { Logo, Image, StarRating } from '@deal/components'
import numeral from 'numeral'
import { Link } from 'react-router-dom'

interface RightReviewsProps {
  showAllStars: boolean
  showReviewNumbers: boolean
  averageRating?: number | null
  reviewNumber: number
  cartIcon?: string
}

const RightReviews: React.SFC<RightReviewsProps> = ({
  showAllStars,
  showReviewNumbers,
  averageRating,
  reviewNumber,
  cartIcon
}) => {
  if (!averageRating) {
    return null
  }
  const reviewNumberWithCommas = numeral(reviewNumber).format('0,0')

  return (
    <div className={styles.rightContainer}>
      {cartIcon && <Image src={cartIcon} height={24} className={styles.logo} />}
      <span className={styles.starComponent}>
        {!showAllStars ? (
          <div className={styles.rating}>
            {`${averageRating} `}
            <span className={styles.ratingStar}>
              <StarRating rating={1} numberOfStars={1} starRatedColor="#f2962d" />
            </span>
          </div>
        ) : (
          <StarRating rating={averageRating} starRatedColor="#f2962d" />
        )}
      </span>
      {showReviewNumbers ? (
        <span className={styles.numbersText}>({reviewNumberWithCommas})</span>
      ) : null}
    </div>
  )
}

interface LinkWrapperProps extends React.HTMLAttributes<HTMLAnchorElement> {
  url: string
  isInternal: boolean
}

const LinkWrapper: React.SFC<LinkWrapperProps> = ({ url, isInternal, children, ...rest }) => {
  if (!isInternal) {
    return (
      <a href={url} target="_blank" {...rest}>
        {children}
      </a>
    )
  } else {
    return (
      <Link to={url} {...rest}>
        {children}
      </Link>
    )
  }
}

interface CurratedReviewsProps extends RightReviewsProps {
  departmentLabel: string
  icon?: boolean
  logo?: boolean
  url: string
  isInternal: boolean
  handleClick: () => void
}

const CurratedReviews: React.SFC<CurratedReviewsProps> = ({
  icon,
  logo,
  reviewNumber,
  departmentLabel,
  showReviewNumbers,
  averageRating,
  showAllStars,
  url,
  handleClick,
  cartIcon,
  isInternal
}) => {
  return (
    // <a className={styles.widget} href={redirectUrl} target="_blank" onClick={handleClick}>
    <LinkWrapper url={url} onClick={handleClick} className={styles.widget} isInternal={isInternal}>
      <div className={styles.leftContainer}>
        {icon && (
          <div className={styles.iconContainer}>
            <Logo mark="icon" brand="curated" color="dark" className={styles.logo} />
          </div>
        )}
        {logo && (
          <div className={styles.logoContainer}>
            <Logo mark="word" brand="curated" color="dark" className={styles.logo} />
          </div>
        )}
      </div>
      <div className={styles.rightContainerWithLabel}>
        <span className={styles.departmentLabel}>{departmentLabel}</span>
        <div className={styles.rightContainerStars}>
          <RightReviews
            showAllStars={showAllStars}
            showReviewNumbers={showReviewNumbers}
            averageRating={averageRating}
            reviewNumber={reviewNumber}
            cartIcon={cartIcon}
          />
        </div>
      </div>
    </LinkWrapper>
    // </a>
  )
}

export default CurratedReviews
